import { render } from "./EventReport.vue?vue&type=template&id=e5b45b46&scoped=true"
import script from "./EventReport.vue?vue&type=script&lang=js"
export * from "./EventReport.vue?vue&type=script&lang=js"

import "./EventReport.vue?vue&type=style&index=0&id=e5b45b46&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5b45b46"]])

export default __exports__